<div class="text-center">
  <mat-icon>developer_board</mat-icon>
  <h1 *ngIf="_service.id; else noServiceTitle" mat-dialog-title translate>
    dialog.service.update.title
  </h1>
  <ng-template #noServiceTitle>
    <h1 mat-dialog-title translate>dialog.service.create.title</h1>
  </ng-template>

  <div class="modal-body" mat-dialog-content>
    <help-alert
      text="help.page.new_service.field"
      info="help.info"
      description="help.page.new_service.description"
    ></help-alert>

    <div class="card container">
      <div class="row mt-2">
        <div class="col-sm">
          <mat-form-field class="full-width">
            <mat-label translate>dialog.service.generic.name</mat-label>
            <input [(ngModel)]="_service.name" matInput required />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <mat-form-field class="full-width">
            <mat-label translate>dialog.service.generic.code</mat-label>
            <input [(ngModel)]="_service.code" matInput />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <mat-form-field>
            <mat-label translate>dialog.service.generic.priority</mat-label>
            <input [(ngModel)]="_service.priority" matInput />
          </mat-form-field>
        </div>

        <div class="col-sm">
          <mat-form-field>
            <mat-label translate>dialog.service.generic.category</mat-label>
            <mat-select [(ngModel)]="_service.catId" matNativeControl required>
              <mat-option
                *ngFor="let category of categories"
                [value]="category.id"
              >
                {{category.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card container mt-3 border align-items-center">
      <!-- <div class="row mt-2"></div> -->

      <div class="row mt-2">
        <div class="col-sm mt-2">
          <mat-checkbox [(ngModel)]="_service.ticket">
            <span translate>dialog.service.generic.ticket</span>
          </mat-checkbox>
        </div>

        <div class="col-sm" *ngIf="_service.ticket == 1">
          <mat-form-field>
            <mat-label translate>dialog.service.generic.tprefix</mat-label>
            <input [(ngModel)]="_service.ticketPrefix" matInput required />
          </mat-form-field>
        </div>

        <div class="col-sm" *ngIf="_service.ticket == 1">
          <mat-form-field>
            <mat-label translate
              >dialog.service.generic.maxseqtickets</mat-label
            >
            <input
              [(ngModel)]="_service.maxSeqTickets"
              matInput
              type="number"
              min="0"
              max="999"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm mt-2">
          <mat-checkbox [(ngModel)]="_service.booking">
            <span translate>dialog.service.generic.booking</span>
          </mat-checkbox>
        </div>

        <div class="col-sm" *ngIf="_service.booking == 1">
          <mat-form-field>
            <mat-label translate>dialog.service.generic.bprefix</mat-label>
            <input [(ngModel)]="_service.bookPrefix" matInput required />
          </mat-form-field>
        </div>

        <div
          class="col-sm"
          *ngIf="_service.booking == 1 && numberingList && firstById != null"
        >
          <custom-select
            #bookNumbering
            [values]="numberingList"
            [selectFirstById]="firstById"
            title_multiple="custom.bookNumbering.title"
            (change)="numberingChange($event)"
            class="mr-3 full-width"
          ></custom-select>
        </div>
      </div>
    </div>

    <div class="card container mt-3">
      <div class="row mt-2">
        <div class="col-md">
          <mat-form-field class="full-width">
            <mat-label translate>dialog.service.generic.timeFraction</mat-label>
            <input [(ngModel)]="_service.timeFraction" matInput required />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card container mt-3">
      <div class="row mt-2">
        <div class="col-md">
          <mat-form-field class="full-width">
            <mat-label translate>dialog.service.generic.waitLimit1</mat-label>
            <input [(ngModel)]="_service.waitLimit1" matInput />
          </mat-form-field>
        </div>

        <div class="col-md">
          <mat-form-field class="full-width">
            <mat-label translate>dialog.service.generic.waitLimit2</mat-label>
            <input [(ngModel)]="_service.waitLimit2" matInput />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card container mt-3">
      <div class="row mt-2">
        <div class="col-sm">
          <mat-checkbox [(ngModel)]="_service.tktReset">
            <text translate>dialog.service.generic.tktReset</text>
          </mat-checkbox>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <mat-checkbox [(ngModel)]="_service.timeFor">
            <text translate>dialog.service.generic.timefor</text>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer" mat-dialog-actions translate>
  <button
    type="button"
    class="btn btn-outline-danger"
    (click)="cancel()"
    translate
  >
    dialog.service.generic.cancel
  </button>

  <button
    *ngIf="_service.id; else noServiceConfirm"
    type="button"
    class="btn btn-outline-secondary"
    (click)="update()"
    translate
  >
    dialog.service.update.confirm
  </button>

  <ng-template #noServiceConfirm>
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="create()"
      translate
    >
      dialog.service.create.confirm
    </button>
  </ng-template>
</div>
